import { toolKeys } from '@lbmx/types';

export const routePermissions = {
  home: toolKeys.AUTHENTICATED,
  UserModule: toolKeys.AUTHENTICATED,
  UserModule_userProfile: toolKeys.AUTHENTICATED,
  login: toolKeys.AUTHENTICATED,
  logout: toolKeys.AUTHENTICATED,
  AdministrationModule: toolKeys.ADMINISTRATION,
  TestingModule: toolKeys.EDI_TESTING,
  ContactSupport: toolKeys.EDI_TESTING,
  DocumentSpecification: toolKeys.EDI_TESTING,
  TestToolGuide: toolKeys.EDI_TESTING,
  TestingModule_view: toolKeys.EDI_TESTING_VIEW,
  OnboardingModule: toolKeys.EDI_ONBOARDING,
  OnboardingModule_MemberOnboarding: toolKeys.EDI_ONBOARDING_MEMBER,
  OnboardingModule_SupplierOnboarding: toolKeys.EDI_ONBOARDING_SUPPLIER,
};
